// Temporary local enums for CADY numeric ID attributes that don't yet have
// upstream equivalents in @VelocitySquared/cady-sunny16-commerce-integration-models.
// When the C# side adds these enums and regenerates the package, delete this
// file and switch imports to the package.
//
// Precedent: CadyScene and CadySessionType already live upstream — do not
// redefine them here. Import them from the integration-models package instead.
//
// See `docs/decisions/2026.05.06-001-ADR-010-cady-numeric-attributes-for-behavioral-logic.md`.

export enum CadyAddOn {
  OutdoorScene = 1,
  ArtistTouch = 4,
  BlackAndWhiteProofs = 9,
  Portfolio = 11,
  AllDigitals = 12,
  Hair = 18,
  Makeup = 19,
  GoAnywhere = 24,
  PremierRetouching = 30
}

export enum CadySessionCategory {
  Elite = 1,
  MostPopular = 2,
  Traditional = 3,
  Basic = 4
}
